// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__9GA1b","label":"SetPasswdForm_label__1lrA6"};